import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { TextInput, DropdownWithSearch, Dropdown, Image } from "hesus-ui-kit";
import HaulierCompany from "./HaulierCompany";
import { GridRow, GridItem } from "../../AddEditSupplier.styled";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import commentIcon from "@icons/ic-comment-blue.svg";

import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";
import { filterUnit } from "@utils/utils";
import "../../AddEditSupplier.scss";

const Haulage = (props) => {
  const {
    t,
    search,
    onlyTranport,
    item,
    isEdit,
    transportTypes,
    onChange,
    itemIndex,
    platformCountryId,
    multiCurrencyObject,
  } = props;
  const [showComment, setShowComment] = useState(false);
  const [supplierPlanningComment, setSupplierPlanningComment] = useState(
    item.planningComment.value
  );
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    const currenciesList = Object.entries(multiCurrencyObject).map((entry) => {
      return { label: entry[1], value: entry[0] };
    });
    setCurrencies(currenciesList);
  }, []);

  useEffect(() => {
    onChange(supplierPlanningComment, itemIndex, "planningComment");
  }, [supplierPlanningComment]);

  const showCommentBox = () => {
    setShowComment(true);
  };

  return (
    <>
      {/* {item?.solutionId?.error !== "" && (
        <GridRow column="1fr">
          <RequiredMessagePara fontStyle="italic" maxWidth="auto">
            {item.solutionId.error}
          </RequiredMessagePara>
        </GridRow>
      )} */}
      {onlyTranport && (
        <GridRow column="70% 25%" gap="5%">
          <div className="supplier-planning__dropdown">
            <DropdownWithSearch
              placeholder={t("SUPPLIERS_PLANNING_FORM_TRANSPORT")}
              label={t("SUPPLIERS_PLANNING_FORM_TRANSPORT")}
              value={item.transportId?.value}
              isMulti={false}
              options={transportTypes}
              required
              error={item.transportId.error}
              onChange={(e) => {
                onChange(e, itemIndex, "transportId");
              }}
              labelStyles={
                item?.transportId?.error !== "" ? labelStylesError : labelStyles
              }
              inputClass={
                item?.transportId?.error !== ""
                  ? "dropdown-with-search__dropdown-input-error"
                  : "dropdown-with-search__dropdown-input"
              }
            />
          </div>
        </GridRow>
      )}
      {!onlyTranport && (
        <>
          <GridRow>
            <HaulierCompany
              item={item}
              itemIndex={itemIndex}
              isEditMode={isEdit}
              objectType="haulier"
              onChange={onChange}
              platformCountryId={platformCountryId}
            />
          </GridRow>
          <GridRow column="70% 25%" gap="5%">
            <div className="supplier-planning__dropdown">
              <DropdownWithSearch
                placeholder={t("SUPPLIERS_PLANNING_FORM_TRANSPORT")}
                label={t("SUPPLIERS_PLANNING_FORM_TRANSPORT")}
                value={item.transportId?.value}
                isMulti={false}
                options={transportTypes}
                required
                error={item.transportId.error}
                onChange={(e) => {
                  onChange(e, itemIndex, "transportId");
                }}
                labelStyles={
                  item?.transportId?.error !== ""
                    ? labelStylesError
                    : labelStyles
                }
                inputClass={
                  item?.transportId?.error !== ""
                    ? "dropdown-with-search__dropdown-input-error"
                    : "dropdown-with-search__dropdown-input"
                }
              />
            </div>
            <TextInput
              id="add-supplier-planning-quantity"
              type="text"
              name={item.trucksQuantity.name}
              label={t("SUPPLIERS_PLANNING_FORM_TRUCKS")}
              isFloat
              value={String(item.trucksQuantity.value)}
              onChange={(e) => {
                onChange(e, itemIndex, "trucksQuantity");
              }}
              containerStyles={{ marginTop: "21px" }}
              errorStyles={{ "font-style": "italic" }}
              labelStyles={
                item.trucksQuantity.error !== ""
                  ? labelStylesError
                  : labelStyles
              }
              inputStyles={
                item.trucksQuantity.error !== ""
                  ? inputStylesError
                  : inputStyles
              }
              error={item.trucksQuantity.error}
              placeholder={t("SUPPLIERS_PLANNING_FORM_TRUCKS")}
            />
          </GridRow>
          <GridRow column="1fr 1fr 1fr">
            <TextInput
              id="add-supplier-planning-quantity"
              type="text"
              label={t("SUPPLIERS_PLANNING_FORM_PRICE")}
              isFloat
              name={item.price.name}
              value={String(item.price.value)}
              onChange={(e) => {
                onChange(e, itemIndex, "price");
              }}
              containerStyles={{ marginTop: "21px" }}
              errorStyles={{ "font-style": "italic" }}
              labelStyles={
                item.price.error !== "" ? labelStylesError : labelStyles
              }
              inputStyles={
                item.price.error !== "" ? inputStylesError : inputStyles
              }
              required
              error={item.price.error}
              placeholder={t("SUPPLIERS_PLANNING_FORM_PRICE")}
            />
            <div>
              <Dropdown
                id="add-enquiry-unit"
                label={t("SUPPLIERS_PLANNING_FORM_UNIT")}
                name={item.unit.name}
                value={item.unit.value}
                onChange={(e) => {
                  onChange(e, itemIndex, "unit");
                }}
                defaultOption={t("UNIT")}
                options={filterUnit(item.itemInfo.unit, t)}
                labelStyles={
                  item.unit.error !== "" ? labelStylesError : labelStyles
                }
                inputStyles={
                  item.unit.error !== "" ? inputStylesError : inputStyles
                }
                required
                error={item.unit.error}
              />
            </div>
            {currencies.length > 1 && (
              <div className="catalog-name">
                <Dropdown
                  label={t("SELLING_PRICE_CURRENCY")}
                  name="sellingPirceCurrency"
                  value={String(item.currency.value)}
                  defaultOption={t("SELECT_CURRENCY")}
                  options={currencies}
                  required
                  onChange={(e) => {
                    onChange(e, itemIndex, "currency");
                  }}
                  labelStyles={
                    item.currency.error !== "" ? labelStylesError : labelStyles
                  }
                  inputStyles={
                    item.currency.error !== "" ? inputStylesError : inputStyles
                  }
                  containerStyles={{ marginBottom: "7px" }}
                  error={item.currency.error}
                />
              </div>
            )}
          </GridRow>
          {((!showComment && !isEdit) ||
            (isEdit && item.planningComment.value === "")) && (
            <GridRow>
              <GridItem
                fontSize="14px"
                fontWeight="700"
                color="#15aee5"
                padding="5px 10px"
                textAlign="left"
                gap="0rem"
                leftRadius="0px"
                rightRadius="0px"
                textDecoration="underline"
                onClick={showCommentBox}
              >
                <Image
                  src={commentIcon}
                  className="add-edit-supplier-list__image-action-icon"
                  alt={t("SUPPLIERS_PLANNING_FORM_HAULIER_COMMENT")}
                  title={t("SUPPLIERS_PLANNING_FORM_HAULIER_COMMENT")}
                />
                <span style={{ cursor: "pointer" }}>
                  {t("SUPPLIERS_PLANNING_FORM_HAULIER_COMMENT")}
                </span>
              </GridItem>
            </GridRow>
          )}
          {(showComment || item.planningComment.value !== "") && (
            <GridRow column="1fr">
              <GridItem>
                <CKEditorText
                  descriptionData={supplierPlanningComment}
                  setDescriptionData={setSupplierPlanningComment}
                />
              </GridItem>
            </GridRow>
          )}
        </>
      )}
    </>
  );
};

Haulage.propTypes = {
  t: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  search: PropTypes.string,
  onlyTranport: PropTypes.bool,
  platformCountryId: PropTypes.number,
};

Haulage.defaultProps = {
  isEdit: false,
  search: "",
  onlyTranport: false,
  platformCountryId: null,
};
export default withTranslation()(Haulage);
